const getters = {
    screen: state => state.common.screen,
    routeList:state => state.common.routeList,
    register_step:state => state.common.register_step,
    register_role:state => state.common.register_role,
    screenWidth:state => state.common.screenWidth,
    userInfo: state => state.user.userInfo,
    userToken:state => state.user.userToken,
    userRole:state => state.user.userRole,
    personalInfo:state => state.user.personalInfo,
    levels:state => state.user.levels,
    activeName: state => state.common.activeName,
}

export default getters
